import styled from 'styled-components';
import { ItemList } from '../../ui/ItemCard/styled';
import { PlaceholderBlock } from '../../../styled/placeholders.styled';

export const AgencyFilterContainer = styled.section`
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

export const AgencyList = styled(ItemList)`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  width: 100%;
`;

export const ChipPlaceholder = styled(PlaceholderBlock)`
  flex-shrink: 0;
  width: 100px;
  height: 44px;
  margin: 0;
  border-radius: 100px;
`;
